import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { getBanner, getBannerSuccess } from '@app/actions/homepage/banner.action';
import { ValidationUtil } from '@app/common/util/validation.util';
import { MyRollingBannerModel } from '@app/models/homepage/my-rolling-banner.module';
import { BannerSearchState, loadBannerSearchItems } from '@app/selectors/homepage/banner.selector';
import { SwiperService } from '@app/services/common/swiper.service';
import { ImageCacheService } from '@app/services/system/image-cache.service';
import { Store } from '@ngrx/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription } from 'rxjs';



@Component({
  selector: 'hp-slider',
  templateUrl: './hp-slider.component.html',
  styleUrls: ['./hp-slider.component.css']
})
export class HpSliderComponent implements OnInit, OnDestroy {

  @Input() urlWownet : String = "";
  loadBannerItems$ = new Observable<MyRollingBannerModel[]>;

  deviceType:string = ''

  contentsBanner : MyRollingBannerModel[] = [];
  contentsBannerMo : MyRollingBannerModel[] = [];

  todate: Date = new Date();
  subBanner = {} as Subscription;

  dateUS$ = new Observable<string>();
  isCache:boolean = true;

  swiperConfig = {
    spaceBetween: 0,
    slidesPerView: 1,
    loop: true,
    loopedSlides: 1,
    centeredSlides: true,
    grabCursor: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
       delay: 4000,
       disableOnInteraction: false,
    },
  }

  constructor(private _bannerStore: Store<BannerSearchState> ,
    private _swiperService:SwiperService,
    private deviceService: DeviceDetectorService,
    private _http: HttpClient,
    private _cacheImage: ImageCacheService,
    )
    {
    this.deviceType = this.deviceService.isDesktop()? 'PC':'MOBILE'
    this.loadBannerItems$ = this._bannerStore.select(loadBannerSearchItems);
    }
  ngOnDestroy(): void {
    let hasValue = this.subBanner.closed != undefined
    if(this.subBanner && hasValue){
      this.subBanner.unsubscribe()
    }
    this._bannerStore.dispatch(getBannerSuccess({banner:[]}))
  }

  ngOnInit(): void {

    this.loadBanner();

  }

  loadBanner() : void {
    const y = this.todate.getFullYear();
    const m = this.todate.getMonth() + 1 < 10 ? '0' + (this.todate.getMonth() + 1) : this.todate.getMonth() + 1;
    const d = this.todate.getDate() < 10 ? '0' + this.todate.getDate() : this.todate.getDate();

    const dateNow = '' + y + m + d;

    let params = {
      kind : "HP",
      dateNow : dateNow
    }

    this._bannerStore.dispatch(getBanner({ params: params }));

    this.subBanner = this.loadBannerItems$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
          for (let item of res) {
              let a = {} as MyRollingBannerModel;
              let iscache1 = this._cacheImage.isInCache(item.fileName)
              if (iscache1) {
                a = { ...item, pathUrl: String(this._cacheImage.getImage(item.fileName)) };
              } else {
              this.isCache = false;
                a = { ...item, pathUrl: this.urlWownet + item.filePath + item.fileName };
                this.setImageInCache(item.fileName, this.urlWownet + item.filePath + item.fileName);
              }
              if(this.deviceType == 'PC' && a.pathKind == 'PC' || a.pathKind === ''){
                this.contentsBanner.push(a)
              }
              if(this.deviceType == 'MOBILE' && a.pathKind == 'PHONE' || a.pathKind === ''){
                this.contentsBanner.push(a)
              }
              console.log(this.contentsBanner);
          }

          setTimeout(() => {
            this.createSwipper();
          }, 1000);

      }
  });

  }

  createSwipper(){
    this._swiperService.createSwiper(
      'mainVisual .swiper-container',
      this.swiperConfig
    );


  }

  private setImageInCache(key: string, url: string): Promise<void> {
		return new Promise<void>((resolve, reject) => {
		  const headers = new HttpHeaders({
			'Access-Control-Allow-Origin': '*' // Thêm header của bạn ở đây
		  });

		  this._http.get(url, {
			responseType: 'blob',
			headers: headers
		  }).subscribe(
			(response: Blob) => {
			  const reader = new FileReader();
			  reader.readAsDataURL(response);
			  reader.onloadend = () => {
				const imageData = reader.result as string;
				this._cacheImage.setImage(key, imageData);
				resolve(); // Gọi resolve khi hoàn thành việc lưu trữ vào cache
			  };
			},
			(error) => {
			  reject(error); // Gọi reject nếu có lỗi xảy ra trong quá trình tải hình ảnh
			}
		  );
		});
	  }

}
